import { useContext } from "react";
import { MenuOrderTypeContext } from "../context/MenuOrderTypeContext";

export const useMenuOrderType = () => useContext(MenuOrderTypeContext);
